import React from "react";
import OwLabel from "../OwLabel/OwLabel";
import "./OwBadge.scss";

type Props = {
    title: string;
    bgColor: string;
    leftIconClass?: string;
    textColor?: string;
    skipTranslate?: boolean;
};

const OwBadge: React.FC<Props> = (props) => {
    return (
        <div data-testid={"badge"} className={"badge ms-1 " + props.bgColor} style={{ color: props.textColor }}>
            {!props.skipTranslate ? (
                <OwLabel leftIconClass={props.leftIconClass} title={props.title} />
            ) : (
                <>
                    <i role={"icon"} className={props.leftIconClass} />
                    {props.title}
                </>
            )}
        </div>
    );
};

export default OwBadge;
